<template>
    <div>
        <h2>Room Service</h2>
        <vx-card class="mt-5" v-if="orders.length > 0">

            <h4>{{ $t('placedOrders') }}</h4>
            <vs-divider />

            <p align="center" v-if="getPlacedOrders(orders).length == 0">
                {{ $t('noPlacedOrders') }}
            </p>

            <div v-if="getPlacedOrders(orders).length > 0 && order.reservation_id == user.hotel.num_reserva" class="op-block mt-5" v-for="(order, order_index) in getPlacedOrders(orders)" :key="order_index">
                <p><span style="font-weight: bold;">Hotel:</span> {{ order.hvg_desc }}</p>
                <p><span style="font-weight: bold;">Data:</span> {{ formateDate(order.request_date) }}</p>
                <p><span style="font-weight: bold;">Observações:</span> {{ order.details }}</p>  
                <div class="vs-component vs-divider"><span class="vs-divider-border after vs-divider-border-primary" style="width: 100%; border-top-width: 1px; border-top-style: solid;"></span><span class="vs-divider-border before vs-divider-border-primary" style="width: 100%; border-top-width: 1px; border-top-style: solid;"></span></div>
                <div class="vs-component vs-con-table vs-table-primary">
                    <header class="header-table vs-table--header"></header>
                    <div class="con-tablex vs-table--content">
                        <div class="vs-con-tbody vs-table--tbody ">
                            <table class="vs-table vs-table--tbody-table">
                                <thead class="vs-table--thead">
                                    <tr>
                                        <th class="w-3/6" colspan="1" rowspan="1">
                                            <div class="vs-table-text">Item</div>
                                        </th>
                                        <th class="w-1/6" colspan="1" rowspan="1">
                                            <div class="vs-table-text">Quantidade</div>
                                        </th>
                                        <th class="w-1/6" colspan="1" rowspan="1">
                                            <div class="vs-table-text">Preço</div>
                                        </th>
                                        <th class="w-1/6" colspan="1" rowspan="1">
                                            <div class="vs-table-text">Total</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, item_index) in order.items" :key="item_index" class="tr-values vs-table--tr tr-table-state-null">
                                        <td class="td vs-table--td"><span>{{ getItemName(item) }}</span></td>
                                        <td class="td vs-table--td"><span>{{ item.quantity }}</span></td>
                                        <td class="td vs-table--td"><span>{{ parseFloat(getPrice(item)).toFixed(2) }} €</span></td>
                                        <td class="td vs-table--td"><span>{{ parseFloat(getPrice(item) * item.quantity).toFixed(2) }} €</span></td>
                                    </tr>
                                    <tr class="tr-values vs-table--tr tr-table-state-null">
                                        <td class="td vs-table--td text-right" colspan="2"><span></span></td>
                                        <td class="td vs-table--td"><span><strong>Total</strong></span></td>
                                        <td class="td vs-table--td"><span>{{ parseFloat(getTotal(order.items)).toFixed(2) }} €</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <vs-list v-if="getPlacedOrders(orders) > 0 && user.hotel.hotel_id" v-for="(order, order_index) in getPlacedOrders(orders)" :key="order_index">
                <vx-card class="mb-3">
                    <vs-list-item color="dark" :title="formateDate(order.request_date)"></vs-list-item>
                    <vs-list-item v-for="(item, item_index) in order.items" :key="item_index" :title="getItemName(item)" :subtitle="item.sub_capitulo.descricao">                                    
                    </vs-list-item>
                    <div v-if="order.details" class="mt-3">
                        Observações: {{ order.details }}
                    </div>
                    <div class="pb-10">
                        <vs-button class="float-right mt-3" color="danger" v-on:click="cancelOrder(order.id)">{{ $t('cancels') }}</vs-button>
                    </div>
                </vx-card>    
            </vs-list> -->

            <!-- <vs-tabs>
                <vs-tab class="px-0" v-for="(status, status_index) in orders" :key="status_index" :label="status.name">
                    <p align="center" v-if="status.orders.length == 0">Não há Pedido(s) {{status.name}}(s).</p>
                    <vs-list v-for="(order, order_index) in status.orders" :key="order_index">
                        <vx-card style="background: #eee;" class="mb-3">
                            <vs-list-item color="dark" :title="formateDate(order.request_date)" v-if="status.id == 1"></vs-list-item>
                            <vs-list-item v-for="(item, item_index) in order.items" :key="item_index" :title="item.sub_capitulo.nome + ' x ' + item.quantity" :subtitle="item.sub_capitulo.descricao">                                    
                            </vs-list-item>
                            <div v-if="order.details" class="mt-3">
                                Observações: {{ order.details }}
                            </div>
                            <div v-if="status.id == 1" class="pb-10">
                                <vs-button class="float-right mt-3" size="small" color="danger" v-on:click="cancelOrder(order.id)">Cancelar</vs-button>
                            </div>
                        </vx-card>    
                    </vs-list>
                </vs-tab>
            </vs-tabs>  -->
        </vx-card>

        <div class="mt-5" v-if="user.hotel.hotel_id && orders.length == 0">
            <vx-card>
                <p align="center">{{ $t('noOrders') }}</p>
            </vx-card>
        </div>

        <div class="mt-5" v-if="!user.hotel.hotel_id">
            <vx-card>
                <p align="center">{{ $t('noStay') }}</p>
            </vx-card>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    data: () => {
        return {
            orders: [],
            user: JSON.parse(localStorage.getItem('userSession'))
        }
    },

    methods: {
        getTotal(items) {
            let total = 0

            items.forEach(item => {
                total = parseFloat(parseFloat(total) + this.getPrice(item));
                total = total * item.quantity;
            });

            return parseFloat(total);
        },
        getPrice(item) {
            let price = item.measure_id > 0 ? item.sub_capitulo.sub_capitulo_medidas.find(x => x.id == item.measure_id).preco : item.sub_capitulo.preco;

            return parseFloat(price);
        },
        getItemName(item) {
            let name;

            if(item.measure_id != 0) {
                let measure = item.sub_capitulo.sub_capitulo_medidas.find(x => x.id == item.measure_id);
                name = item.sub_capitulo.nome + ' ' + measure.volume + ' ' + measure.medida;
            } else {
                name = item.sub_capitulo.nome;
            }

            return name;
        },
        getPlacedOrders(orders) {
            return orders.find(x => x.id == 1).orders;
        },
        getOrders() {
            this.$vs.loading();
            let token = localStorage.getItem('usertoken');
			
			this.$api({
				method: 'get',
				url: '/myvilagale/hotel/' + this.user.hotel.hotel_id + '/client/' + this.user.id + '/orders/' + this.user.hotel.num_reserva,
				params: {
					token: token,
				},
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
			.then((res) => {
                this.orders = res.data;
                /* for (let i = 0; i < res.data.length; i++) {
                    this.$set(this.orders, i, res.data[i]);
                } */
				this.$vs.loading.close();
			})
			.catch((err) => {
				this.$vs.loading.close();
			});
        },

        cancelOrder(order_id) {
            this.$vs.loading();

            let token = localStorage.getItem('usertoken');
            let user = JSON.parse(localStorage.getItem('userSession'));
            let params = {
                id: order_id
            }
            let that = this;

            this.$api.post( '/myvilagale/hotel/' + user.hotel.hotel_id + '/cancel/order?token=' + localStorage.getItem('usertoken'),
            params,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('usertoken')
                }

            }).then(function(res) {
                that.$vs.loading.close();
                that.getOrders();
                that.$vs.notify({
                    text: 'Pedido cancelado com sucesso!',
                    color:'success',
                    position:'bottom-right',
                    iconPack: 'feather',
                    icon:'icon-check'
                });
            })
            .catch(function(err) {
                that.$vs.loading.close();
            });
        },

        formateDate(date) {
            moment.locale('pt');
            let new_date = moment(date).format('L');            
            new_date = new_date.replace('/', '-');
			new_date = new_date.replace('/', '-');	
            return new_date; 
        }
    },

    mounted() {
        if (this.user.hotel.hotel_id) {
            this.getOrders();
        }
    }
}
</script>

<style scoped>

</style>